var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'piechart' + _vm.lang,staticStyle:{"width":"100%","height":"355px","direction":"ltr"},attrs:{"id":("chartdiv" + _vm.index)}})}
var staticRenderFns = []

export { render, staticRenderFns }